import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior () {
		return {
			x: 0,
			y: 0
		}
	},
	routes: [
		{
			path: '/login',
			component: () => import('./views/Auth/Login.vue'),
			meta: {
				role: 'Client',
				requiresAuth: false,
			}
		},
		// {
		// 	path: '/loginAuthor',
		// 	component: () => import('./views/Auth/Login.vue'),
		// 	meta: {
		// 		role: 'Author',
		// 		requiresAuth: false,
		// 	}
		// },
		// {
		// 	path: '/loginAdmin',
		// 	component: () => import('./views/Auth/Login.vue'),
		// 	meta: {
		// 		role: 'Admin',
		// 		requiresAuth: false,
		// 	}
		// },

		{
			path: '/reset',
			component: () => import('./views/Auth/Reset.vue'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '/register',
			component: () => import('./views/Auth/Register.vue'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '/registrationAuthor',
			component: () => import('./views/Auth/Register.vue'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '',
			component: () => import('./layouts/Main.vue'),
			meta: {
				requiresAuth: true
			},
			children: [
				{
					path: '/',
					name: 'home',
					component: () => import('./views/Home.vue')
				},
				// Типы работ
				{
					path: '/typeWorks',
					component: () => import('./views/typeWorks.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Предметы
				{
					path: '/subjects',
					component: () => import('./views/subjects.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Типы работ
				{
					path: '/exchange',
					component: () => import('./views/Exchange.vue'),
					meta: {
						role: 'Author',
					}
				},
				{
					path: '/quality-assurance',
					component: () => import('./views/QualityAssurance.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Клиенты
				{
					path: '/clients',
					component: () => import('./views/Clients/list.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/client/:id',
					component: () => import('./views/Clients/Card.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/client/:id/edit',
					component: () => import('./views/Clients/Edit.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Клиенты
				{
					path: '/clientsM',
					component: () => import('./views/ClientsManager/list.vue'),
					meta: {
						role: 'Manager',
					}
				},
				{
					path: '/clientM/:id',
					component: () => import('./views/ClientsManager/Card.vue'),
					meta: {
						role: 'Manager',
					}
				},
				{
					path: '/clientM/:id/edit',
					component: () => import('./views/ClientsManager/Edit.vue'),
					meta: {
						role: 'Manager',
					}
				},
				// Авторы
				{
					path: '/authorM/:id',
					component: () => import('./views/AuthorsM/Card.vue'),
					meta: {
						role: 'Manager',
					}
				},
				{
					path: '/authors',
					component: () => import('./views/Authors/list.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/settings',
					component: () => import('./views/Settings.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/author/:id',
					component: () => import('./views/Authors/Card.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/author/:id/edit',
					component: () => import('./views/Authors/edit.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Финансы
				{
					path: '/finance',
					component: () => import('./views/Finances.vue'),
				},
				// Менеджеры
				{
					path: '/managers',
					component: () => import('./views/Managers/list.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/create',
					component: () => import('./views/Managers/EditManager.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/:id',
					component: () => import('./views/Managers/Manager.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/:id/edit',
					component: () => import('./views/Managers/EditManager.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/manager/:id/edit-sites',
					component: () => import('./components/profile/ManagerSitesProfiles.vue'),
					meta: {
						role: 'Admin',
					}
				},

				// Сайты
				{
					path: '/sites',
					component: () => import('./views/Sites/List.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/sites/:mode/:id?',
					component: () => import('./views/Sites/Item.vue'),
					meta: {
						role: 'Admin',
					}
				},
				{
					path: '/profile/sites',
					component: () => import('./components/profile/ManagerSitesProfiles.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Шаблонные ответы
				{
					path: '/templates',
					component: () => import('./views/Templates.vue'),
					meta: {
						role: 'Admin',
					}
				},
				// Профиль
				{
					path: '/profile',
					name: 'profile',
					component: () => import('./views/Profile')
				},
				{
					path: '/profile/edit',
					name: 'profileEdit',
					component: () => import('./views/EditProfile')
				},
				// Заказы
				{
					path: '/orders',
					name: 'orders',
					component: () => import('./views/Orders/Orders')
				},
				{
					path: '/orders/create',
					name: 'createOrder',
					component: () => import('./views/Orders/CreateOrder')
				},
				{
					path: '/order/:id',
					name: 'order',
					component: () => import('./views/Orders/Order')
				},
				// Тех.поддержка
				{
					path: '/support',
					name: 'supportList',
					component: () => import('./views/Support/List')
				},
				{
					path: '/support/:id',
					name: 'supportCard',
					component: () => import('./views/Support/Card')
				},
				// Дела
				{
					path: 'tasks',
					name: 'tasks',
					component: () => import('./views/Affairs/Affairs')
				},
				// Статистика
				{
					path: 'stats',
					name: 'stats',
					component: () => import('./views/Stats/Stats')
				},
				// Packages
				{
					path: '/packages',
					name: 'Packages',
					component: () => import('./views/Packages/List'),
				},

				// Tickets
				{
					path: '/tickets',
					name: 'Tickets',
					component: () => import('./views/Tickets/List'),
				},
				{
					path: '/ticket/create',
					name: 'TicketsCreate',
					component: () => import('./views/Tickets/Create')
				},
				{
					path: '/ticket/create/:clientId',
					name: 'ClientTicketsCreate',
					component: () => import('./views/Tickets/Create')
				},
				{
					path: '/ticket/:id',
					name: 'TicketsCard',
					component: () => import('./views/Tickets/Card'),
				},
				// Логи
				{
					path: '/logs',
					name: 'ManagersLogs',
					component: () => import('./views/ManagersLogs')
				},
				{
					path: '/guides',
					name: 'PoliciesAndGuides',
					component: () => import('./views/Guide')
				}
			]
		},
		{
			path: '/token/:role/:token',
			component: () => import('./views/Token'),
		},
		{
			path: '/404',
			component: () => import('./views/Error404')
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})

router.afterEach(() => {
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})
router.beforeEach((to, from, next) => {
	if(to.matched.some(record => record.meta.requiresAuth === false)) {
		if(store.getters.isLoggedIn) {
			next("/");
		} else {
			next();
		}

		return;
	}

	if (store.getters.getRole === 'admin' && to.path === '/finance') {
		next("/");
	}

	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		}
		next('/login')
	} else {
		next()
	}
})

export default router
